export default __webpack_public_path__ + "static/media/choose.8f79b408.jpg";